import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve a stored pdf/file url that may be relative (/api/files/..) to absolute
export const resolveUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};
